var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 6,
    viewBox: "0 0 16 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "act_close",
    d: "M6.51426 0.442092L0.429993 4.87983C0.148814 5.08477 0 5.29127 0 5.46291C0 5.79473 0.533346 6 1.4261 6L14.576 6C15.4677 6 16 5.79499 16 5.46394C16 5.29204 15.8511 5.08885 15.5691 4.88345L9.48496 0.443644C9.09305 0.158121 8.56566 -4.76837e-07 7.99929 -4.76837e-07C7.4333 -6.48499e-05 6.90604 0.156245 6.51426 0.442092Z",
    fill: "#1E3799"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActClose);
export default __webpack_public_path__ + "static/media/act_close.03dba7c1488ebafc762952f8cc74f5e3.svg";
export { ForwardRef as ReactComponent };